import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {Provider} from "mobx-react";
import {reaction} from "mobx";
import firebase from './fb';
import rootStore from './stores/RootStore.js';


// Automatically update firebase and local storage on data changes
reaction(() => JSON.stringify(rootStore), json => {

    console.log('storing');
    localStorage.setItem('rootStore',json);
    if (rootStore.userStore.loggedIn) {
        const database = firebase.database();
        database.ref(rootStore.userStore.uid).set(rootStore.wcpStore);
    }

}, {delay: 500});

// Set user store on successful anonymous sign in
firebase.auth().onAuthStateChanged((user) => {

    if (user) {
        console.log('success login: ' + user.uid);
        const uid = user.uid;

        rootStore.userStore.loggedIn = true;
        rootStore.userStore.uid = uid;
    }
});

// Sign in anonymously
firebase.auth().signInAnonymously().catch(function(error) {
    console.log(error.message);
});

ReactDOM.render(<Provider rootStore={rootStore} wcpStore={rootStore.wcpStore} >
                    <App />
                </Provider>, document.getElementById('root'));

